var Config;
var Model = require("backbone-thin").Model;

// simple user config
module.exports = Config = Model.extend({

  defaults:
    {searchText: ""}

});


/** WEBPACK FOOTER **
 ** ./src/g/user.js
 **/